/* eslint-disable no-underscore-dangle */
const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate containsStatusBehavior
  *
  * returns the current status of the form/report
  */

const evaluate = async (format, content, parentContentPath, transientContext, nativeFunctions) => {
  const {
    statusHistory = {}
  } = content;
  const values = Object.values(statusHistory);
  if (values.length === 0) {
    return undefined;
  }
  const sortedStatuses = values.sort((a, b) => {
    if (a._created > b._created) {
      return -1;
    }
    if (a._created > b._created) {
      return 1;
    }
    return 0;
  });
  const currentStatus = sortedStatuses[0];
  const equals = await evaluateSource(format.value, content, parentContentPath, transientContext, nativeFunctions);

  // this tests for equality.  optional.  Otherwise, we return the entire status history
  // object.
  if (equals !== undefined && typeof equals === 'string') {
    return currentStatus.status.toLowerCase() === equals.toLowerCase();
  }
  return currentStatus;
};
module.exports = {
  evaluate
};